// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"853622e0","585":"e589d923","625":"d84ba1a4","643":"458b82a1","947":"cee083e3"}[chunkId] + ".chunk.js";
};